import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import configServ from '../../../../services/config';
import ActionButtons from '../../../Buttons/ActionButtons ';
import { useEffect } from 'react';
import DataGridTable from '../../../DataGridTable/DataGridTable';
import { useSelector } from 'react-redux';

const PaymentTable = ({ handleEditData, isChanged }) => {
    //#region code
    const { user_id } = useSelector((state) => state.GlobalVariables);
    const [catalogDataList, setCatalogDataList] = useState([]);
    const [catalogList, setCatalogList] = useState([]);
    const [loading, setLoading] = useState(true);
    const columns = [
        { field: 'sn', headerName: 'S.NO.', flex: 1 },
        { field: 'voucher_no', headerName: 'Voucher Number', flex: 2 },
        { field: 'customer_name', headerName: 'Customer Name', flex: 2 },
        { field: 'date', headerName: 'Date', flex: 2 },
        { field: 'transactiontype', headerName: 'Transaction Type', flex: 2 },
        { field: 'bankname', headerName: 'Bank Name', flex: 2 },
        { field: 'amount', headerName: 'Amount', flex: 2 },
        {
            field: 'action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => (
                <ActionButtons
                    handlePrint={handlePrint}
                    handleEdit={handleEdit}
                    id={params.id}
                    noPrint
                />
            ),
        },
    ];

    useEffect(() => {
        fetchCatalogList();
    }, [isChanged]);

    const fetchCatalogList = async () => {
        try {
            const { data: res } = await configServ.getpaymentListAdmin({ 'user_id': user_id });
            // console.log(res)
            const result = res.map((item, index) => ({
                sn: index + 1,
                id: item.id,
                voucher_no: item.voucher_no,
                date: item.date,
                transactiontype: item.bankallocation.transactiontype,
                bankname: item.bankallocation.bankname,
                amount: item.amount,
            }));
            // console.log(result)
            setCatalogDataList(res || []);
            setCatalogList(result || []);
            setLoading(false);
        }
        catch (error) {
            // console.log(error);
            setCatalogDataList([]);
            setCatalogList([]);
            setLoading(false);
        }
    }

    const handlePrint = (params) => {
        const data = catalogDataList.filter(x => x.id === params);
        // console.log('data', data)
        // alert(JSON.stringify(data));
        // printInvoice(data[0].invoice_number)
    }

    const handleEdit = (params) => {
        // alert(JSON.stringify(params));
        scrollToTop()
        const data = catalogDataList.filter(x => x.id === params);
        handleEditData(data)
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    //#endregion

    if (loading) {
        return (
            <Box
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <CircularProgress />
            </Box>
        )
    }
    else {
        return (
            <DataGridTable rows={catalogList} columns={columns} />
        );
    }
};

export default PaymentTable;
